<template>
  <tr>
    <td>
      <b-field>
        <p class="control">
          <b-button
            @click="print"
            icon-left="printer"
            size="is-small"
          ></b-button>
        </p>
        <p class="control">
          <b-button
            @click="editJob()"
            icon-left="pencil"
            size="is-small"
          ></b-button>
        </p>
        <p class="control" v-if="hasNotes">
          <b-button
            @click="showDriverNotes"
            icon-left="clipboard-list-outline"
            size="is-small"
            type="is-info"
          ></b-button>
        </p>
      </b-field>
      <span v-if="showNotes">
        <b>{{ this.job.driverNotes }}</b>
      </span>
    </td>
    <td>
      <i>{{ job.status }}</i>
    </td>
    <td>
      {{ this.job.load }}
      <!-- <b-field label="Exisiting Load" custom-class="labelCharge" horizontal>
        <b-select
          placeholder="Select Load"
          v-model="selLoad"
          @input="selectLoad($event)"
        >
          <option
            v-for="(load, index) in allLoads"
            :key="index"
            :value="load.name"
          >
            {{ load.name }}
          </option>
        </b-select>
      </b-field> -->
    </td>
    <td>
      {{ job.origin }}
      <b-button
        @click="showOriginAddress"
        icon-right="information"
        size="is-small"
        style="border:none"
      ></b-button>
      <br />
      <div style="font-size:0.7em;" v-if="showOrigin">
        <b>{{ this.job.originAddress }}</b>
      </div>
    </td>
    <td>
      {{ this.job.dest }}
      <b-button
        @click="showDestinationAddress"
        icon-right="information"
        size="is-small"
        style="border:none"
      ></b-button>
      <br />
      <div style="font-size:0.7em;" v-if="showDestination">
        <b>{{ this.job.destAddress }}</b>
      </div>
    </td>
    <td>{{ this.job.qty }}</td>
    <td>{{ this.job.product }}</td>
    <td>
      {{ this.job.notes }}
    </td>
    <td>
      {{ this.job.truckName }}
      <!-- <b-select
        style="width:95%"
        placeholder="Select truck"
        v-model="selTruck"
        required
        @input="allowSubmit"
      >
        <option
          v-for="(truck, index) in trucks"
          :key="index"
          :value="truck.name"
        >
          {{ truck.description }}
        </option>
      </b-select> -->
    </td>
    <td>
      {{ this.job.driver }}
      <!-- <b-select
        style="width:95%"
        placeholder="Select driver"
        v-model="selDriver"
        id="selDriver"
        required
        @input="allowSubmit"
      >
        <option
          v-for="(driver, index) in drivers"
          :key="index"
          :value="driver.email"
        >
          {{ driver.name + " " + driver.surname }}
        </option>
      </b-select> -->
    </td>
    <b-button
      type="is-primary"
      native-type="submit"
      v-if="isDisabled"
      style="margin-right: 10px"
      >Save</b-button
    >
    <!-- <b-modal :active.sync="showLoadModal" :width="600" scroll="keep" >
      <div class="card">
        <header class="modal-card-head">
          <p class="modal-card-title">Add Load</p>
            <button type="button" class="delete" @click="closeModal()"/>
        </header>
        <div class="card-content">
          <AddLoadForm @saved="saveModal()" @cancelled="closeModal()" :edit="false"></AddLoadForm>
        </div>
      </div>
    </b-modal> -->
    <div id="printMe" style="display: none;">
      <div>
        {{ this.job.load }}
      </div>
      <div>
        {{ this.job.originAddress }}
      </div>
      <div>
        {{ this.job.destAddress }}
      </div>
    </div>
  </tr>
</template>
<script>
import axios from "axios";
// import AddLoadForm from "@/components/AddLoadForm";
import VueHtmlToPaper from "vue-html-to-paper";
import Vue from "vue";

const options = {
  name: "_blank",
  specs: ["fullscreen=yes", "titlebar=yes", "scrollbars=yes"],
  styles: [
    "https://maxcdn.bootstrapcdn.com/bootstrap/4.0.0/css/bootstrap.min.css",
    "https://unpkg.com/kidlat-css/css/kidlat.css"
  ]
};
Vue.use(VueHtmlToPaper, options);

export default {
  name: "JobSheetForm",
  // components: { AddLoadForm },
  props: {
    job: Object
  },
  data() {
    return {
      form: {},
      bookingId: null,
      scheduledDate: new Date(),
      sdate: null,
      drivers: [],
      driver: null,
      selDriver: null,
      trucks: [],
      truck: null,
      selTruck: [],
      unassigned: null,
      isDisabled: false,
      showOrigin: false,
      showDestination: false,
      showNotes: false,
      allLoads: [],
      selLoad: null,
      loads: [],
      showTruck: false,
      hasNotes: false
    };
  },
  methods: {
    selectLoad(load) {
      if (load === "Create New") {
        // do modal
        // on return refresh page
        alert(this.job.id);
        this.$store.commit("setBookingId", this.job.id);
        this.showLoadModal = true;
      }
    },
    print() {
      // Pass the element id here
      this.$htmlToPaper("printMe");
    },
    showOriginAddress() {
      if (this.showOrigin) {
        this.showOrigin = false;
      } else {
        this.showOrigin = true;
      }
    },
    showDestinationAddress() {
      if (this.showDestination) {
        this.showDestination = false;
      } else {
        this.showDestination = true;
      }
    },
    showDriverNotes() {
      if (this.showNotes) {
        this.showNotes = false;
      } else {
        this.showNotes = true;
      }
    },
    allowSubmit() {
      this.isDisabled = true;
    },
    async onSubmit() {
      alert(this.job.id);
    },
    cancel() {
      this.$emit("cancelled");
    },
    async putJob() {
      try {
        await axios.put(
          this.$store.state.apiUrl + "transport/" + this.bookingId,
          {
            action: "TbPutTransportBooking",
            changedFields: {
              scheduledDate: new Date(this.scheduledDate),
              clientCode: this.job[0].clientCode,
              accountCode: this.job[0].accountCode,
              accountName: this.job[0].accountName,
              loadName: this.job[0].loadName,
              pickupAddress: {
                addressName: this.job[0].pickupAddress.addressName,
                address: this.job[0].pickupAddress.address,
                town: this.job[0].pickupAddress.town,
                postcode: this.job[0].pickupAddress.postcode,
                gps: this.job[0].pickupAddress.gps,
                pic: this.job[0].pickupAddress.pic,
                columnPrefix: this.job[0].pickupAddress.columnPrefix
              },
              destinationAddress: {
                addressName: this.job[0].destinationAddress.addressName,
                address: this.job[0].destinationAddress.address,
                town: this.job[0].destinationAddress.town,
                postcode: this.job[0].destinationAddress.postcode,
                gps: this.job[0].destinationAddress.gps,
                pic: this.job[0].destinationAddress.pic,
                columnPrefix: this.job[0].destinationAddress.columnPrefix
              },
              truckName: this.job[0].truckName,
              driverId: this.job[0].driverId,
              driverName: this.job[0].driverName,
              requestedPickupTime: this.job[0].requestedPickupTime,
              requestedDeliveryTime: this.job[0].requestedDeliveryTime,
              contact: this.job[0].contact,
              contactPhone: this.job[0].contactPhone,
              notes: this.job[0].notes,
              qty: this.job[0].qty,
              status: this.job[0].status,
              productName: this.job[0].product,
              estimatedkm: this.job[0].km,
              estimatedWeight: this.job[0].weight,
              qtyType: this.job[0].unit,
              actualQty: 0,
              quotedPrice: this.job[0].rate,
              priceCharged: this.job[0].charged,
              invoiced: false
            }
          },
          {
            headers: {
              Authorization: "Bearer " + this.$cookies.get("user_token"),
              "Content-Type": "application/json"
            }
          }
        );
      } catch (error) {
        console.log(error);
      }
    },
    async getJob(bookingId) {
      // Use Axios to make a call to the API
      try {
        const { data } = await axios.get(
          this.$store.state.apiUrl +
            "transport/" +
            bookingId +
            "?mode=app&row_type=transport_booking",
          {
            headers: {
              Authorization: "Bearer " + this.$cookies.get("user_token"),
              "Content-Type": "application/json"
            }
          }
        );
        this.job = data;
      } catch (error) {
        console.log(error);
      }
    },
    async getDrivers() {
      try {
        const { data } = await axios.get(
          this.$store.state.apiUrl + "user/userByRole/driver",
          {
            headers: {
              Authorization: "Bearer " + this.$cookies.get("user_token"),
              "Content-Type": "application/json"
            }
          }
        );
        this.drivers = data;
      } catch (error) {
        console.log(error);
      }
    },
    async getTrucks() {
      // Use Axios to make a call to the API
      try {
        const { data } = await axios.get(
          this.$store.state.apiUrl + "lookup/vehicle",
          {
            headers: {
              Authorization: "Bearer " + this.$cookies.get("user_token"),
              "Content-Type": "application/json"
            }
          }
        );
        this.trucks = data;
      } catch (error) {
        console.log(error);
      }
    },
    async getLoads() {
      try {
        const { data } = await axios.get(
          this.$store.state.apiUrl +
            "transport?mode=app&row_type=transport_booking&orderby=day",
          {
            headers: {
              Authorization: "Bearer " + this.$cookies.get("user_token"),
              "Content-Type": "application/json"
            }
          }
        );
        var loadss = [];
        var i = 0;
        for (i = 0; i < data.length; i++) {
          this.loads.push({ name: data[i].loadName });
        }
        this.loads.push({ name: "Create New" });

        // we only give the drop down unique load names
        this.loads.filter(function(item) {
          var i = loadss.findIndex(x => x.name === item.name);
          if (i <= -1) {
            loadss.push({ name: item.name });
          }
          return null;
        });

        // only use loads for the schedule date if its set
        if (this.job.sdate !== "Not Scheduled") {
          var sdate = "";
          sdate =
            this.job.sdate.substring(6, 10) +
            "-" +
            this.job.sdate.substring(3, 5) +
            "-" +
            this.job.sdate.substring(0, 2);
          var loadsss = loadss.filter(a => {
            if (a.requestedPickupTime !== undefined) {
              return a.requestedPickupTime.substring(0, 10) === sdate;
            }
            return false;
          });
          this.allLoads = loadsss;
        } else {
          this.allLoads = loadss;
        }
      } catch (error) {
        console.log(error);
      }
    },
    editJob() {
      this.$router.push({ name: "editJob", params: { id: this.job.id } });
    }
  },
  watch: {
    name: {
      handler(p) {
        this.form = JSON.parse(JSON.stringify(p || {}));
      },
      deep: true,
      immediate: true
    }
  },
  beforeMount() {
    this.getDrivers();
    this.getTrucks();
    this.getLoads();
  },
  mounted() {
    this.sdate = this.job.sdate;
    this.selDriver = this.job.driver;
    this.selTruck = this.job.truck;
    if (this.job.truck === "") this.unassigned = "Unassigned";
    this.selLoad = this.job.load;
    if (this.truckName !== "") this.showTruck = true;
    if (this.job.driverNotes !== undefined) this.hasNotes = true;
  }
};
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss"></style>
